<template>
  <div>
    <v-container class="py-0 px-0" id="hide">
      <v-card tile>
        <v-card-text class="p-1">
          <v-row>
            <v-col cols="12" md="2" sm="2">
              <v-text-field
                label="No Transaksi Biaya Buruh"
                dense
                small-chips
                hide-details
                disabled
                v-model="formData.nomor_nota"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="2">
              <v-text-field
                label="Tanggal"
                type="date"
                dense
                small-chips
                hide-details
                v-model="formData.tgl_nota"
                @change="updateInvoice"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="2" sm="2">
              <v-text-field
                label="Nama Penagih"
                type="text"
                dense
                small-chips
                hide-details
                v-model="formData.nama_penagih"
                @change="updateInvoice"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" sm="6">
              <v-text-field
                label="Keterangan"
                type="text"
                dense
                small-chips
                hide-details
                v-model="formData.keterangan"
                @change="updateInvoice"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row class="invoice-item">
            <v-col cols="12" md="3" lg="3">
              <v-autocomplete
                label="No TTPB (KS)"
                outlined
                dense
                hide-details
                :loading="loading.ks"
                :items="items.ks"
                v-model="invoiceDetilFormData.ttpb"
                @change="fetchKsDetail"
                ref="focusNoTTB"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="3" lg="3">
              <v-text-field
                label="Total Koli In"
                outlined
                hide-details
                dense
                disabled
                v-model="info.total_koli_in"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" lg="3">
              <v-text-field
                label="Total M3"
                outlined
                hide-details
                dense
                disabled
                v-model="info.total_m3"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" lg="3">
              <v-text-field
                label="Total Ton"
                outlined
                hide-details
                dense
                disabled
                v-model="info.total_ton"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="3" sm="3">
              <v-autocomplete
                label="Jenis TTPB"
                :items="items.jenisTTPB"
                outlined
                dense
                hide-details
                v-model="invoiceDetilFormData.jenis_ttpb"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="3" sm="3">
              <v-autocomplete
                label="Kategori Upah"
                :items="items.kategoriUpah"
                outlined
                dense
                hide-details
                v-model="invoiceDetilFormData.kategori_upah"
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="6">
              <v-text-field
                type="text"
                label="Keterangan"
                outlined
                dense
                small-chips
                hide-details
                v-model="invoiceDetilFormData.keterangan"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="6" sm="6" class="d-flex align-center">
              <h3 class="mr-2">HB Kubikasi:</h3>
              <v-text-field
                type="text"
                label="Jumlah"
                outlined
                dense
                small-chips
                hide-details
                v-model="invoiceDetilFormData.jumlah"
                style="width: 80px"
              ></v-text-field>
              <span class="mx-1">x</span>
              <v-text-field
                type="text"
                label="Harga"
                outlined
                dense
                small-chips
                hide-details
                v-model="hargaFormInvoiceDetil"
                style="width: 200px"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="4" sm="4" class="d-flex">
              <v-text-field
                type="text"
                label="Kalkulasi Upah"
                outlined
                dense
                small-chips
                hide-details
                disabled
                v-model="kalkulasi_upah"
              ></v-text-field>
            </v-col>

            <v-col cols="12" md="1" sm="1">
              <v-btn
                color="primary"
                small
                :loading="loading.invoiceDetil"
                @click="addInvoiceDetil"
              >
                Simpan
              </v-btn>
            </v-col>

            <!-- <v-col cols="12" v-if="info.total_koli_in">
              <table>
                <tr>
                  <td>
                    <h4>Total Koli In</h4>
                  </td>
                  <td><h4>:</h4></td>
                  <td>
                    <h4>{{ info.total_koli_in }}</h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Total TON</h4>
                  </td>
                  <td><h4>:</h4></td>
                  <td>
                    <h4>{{ info.total_ton }}</h4>
                  </td>
                </tr>
                <tr>
                  <td>
                    <h4>Total M3</h4>
                  </td>
                  <td>
                    <h4>:</h4>
                  </td>
                  <td>
                    <h4>{{ info.total_m3 }}</h4>
                  </td>
                </tr>
              </table>
            </v-col> -->

            <v-col
              cols="12"
              md="12"
              lg="12"
              class="overflow-auto"
              style="height: 250px"
            >
              <v-simple-table
                height="250px"
                fixed-header
                dense
                class="small-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left">KS</th>
                      <th class="text-left">KC / NoCont</th>
                      <th class="text-left">KodeTTB / NoTTB</th>
                      <!-- <th class="text-left">Kondisi Pengiriman</th> -->
                      <!-- <th class="text-left">Pengirim</th> -->
                      <th class="text-left">Penerima</th>
                      <th class="text-left">Koli In</th>
                      <th class="text-left">Keterangan</th>
                      <th class="text-left">Kubikasi</th>
                      <th class="text-left">Tonase</th>
                      <th class="text-left">Kategori Upah</th>
                      <th class="text-left">Jumlah Dihitung</th>
                      <th class="text-left">Harga Satuan</th>
                      <th class="text-left">Total</th>
                      <th class="text-left">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in invoiceDetil" :key="item.id">
                      <td>{{ item.ks }}</td>
                      <td>{{ item.kc }} / {{ item.nomor_container }}</td>
                      <td>{{ item.ttb.kodettb }} / {{ item.ttb.nottb }}</td>
                      <!-- <td>{{ item.ttb.kondisi_detil.kondisi }}</td> -->
                      <!-- <td>{{ item.ttb.pengirim_detil.nama }}</td> -->
                      <td>{{ item.ttb.penerima_detil.nama_lengkap }}</td>
                      <td>{{ item.container_detil.koli_in }}</td>
                      <td>{{ item.keterangan }}</td>
                      <td>{{ getKubikasi(item.ttb.ttb_rinci) }}</td>
                      <td>{{ getTonase(item.ttb.ttb_rinci) }}</td>
                      <td>{{ item.kategori_upah }}</td>
                      <td>{{ item.jumlah }}</td>
                      <td>{{ formatCurrency(item.harga_satuan) }}</td>
                      <td>{{ formatCurrency(item.kalkulasi_upah) }}</td>
                      <td>
                        <v-icon @click="deleteItem(item.ttb.kodettb)">
                          mdi-delete
                        </v-icon>
                      </td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="3" lg="3" style="height: 250px">
              <v-btn
                color="primary"
                elevation="2"
                class="w-100 mt-2"
                @click="printInvoice"
                :loading="state.loadingPrint"
                >Print Nota</v-btn
              >
            </v-col>

            <v-col cols="12" md="9" lg="9">
              <table>
                <tbody>
                  <tr>
                    <td colspan="5">
                      <h4>Total</h4>
                    </td>
                    <td>=</td>
                    <td>
                      {{ total_semua }}
                    </td>
                  </tr>
                  <tr>
                    <td colspan="5">
                      <h4>Total Dibayar Ke Buruh</h4>
                    </td>
                    <td>=</td>
                    <td>
                      <v-text-field
                        type="text"
                        dense
                        small-chips
                        hide-details
                        v-model="total"
                        @blur="updateInvoice"
                        @keydown.enter="updateInvoice"
                      ></v-text-field>
                    </td>
                  </tr>
                </tbody>
              </table>

              <v-text-field
                label="Terbilang"
                outlined
                dense
                small-chips
                hide-details
                class="mt-2"
                disabled
                v-model="formData.terbilang"
              ></v-text-field>

              <!-- <v-text-field
                label="Keterangan Tagihan"
                outlined
                dense
                small-chips
                hide-details
                class="mt-2"
                v-model="formData.keterangan_barang"
                @blur="updateInvoice"
                @keydown.enter="updateInvoice"
              ></v-text-field> -->
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-container>
    <main
      class="report"
      v-if="!state.noData && !state.loading && data.nomor_nota"
      id="section-print"
    >
      <!-- <main class="report" id="section-print"> -->
      <div class="header">
        <div class="tanggal">
          {{ tgl_nota_print }}
        </div>
        <div class="nomor-nota">
          <h6>{{ formData.nomor_nota }}</h6>
          <i>Telah Dibayarkan Kepada:</i>
          <p class="mt-3 mb-3">{{ formData.nama_penagih }}</p>
        </div>
      </div>
      <table class="table">
        <thead>
          <tr>
            <th width="45%" class="text-left"></th>
            <th class="text-center">Koli</th>
            <th class="text-center">M3</th>
            <th class="text-right">Upah Buruh</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="item in data.invoice_detil" :key="item.id">
            <td width="45%">
              {{ item.ttb.nottb }}/{{ item.ttb.penerima_detil.nama_lengkap }}
            </td>
            <td class="text-center">{{ item.ttb.total_koli }}</td>
            <td class="text-center">{{ item.jumlah }}</td>
            <td class="text-right">
              {{ formatCurrency(item.kalkulasi_upah) }}
            </td>
          </tr>
          <tr>
            <td width="45%"></td>
            <td></td>
            <td></td>
            <td class="text-right" style="border-top: 1px solid black;">
              <b>{{ total_semua }}</b>
            </td>
          </tr>
        </tbody>
      </table>
      <div class="footer mt-4">
        <div class="keterangan">
          <p><b>Keterangan Lunas:</b></p>
        </div>
        <div class="rincian">
          <div class="total-upah">
            <h6>Total Upah Buruh</h6>
            <h6>Rp{{ total_semua }}</h6>
          </div>
        </div>
        <div class="ttd">
          <div class="tgl-ttd">{{ tgl_nota_print }}</div>
          <div class="menerima">Yg menerima,</div>
        </div>
      </div>
    </main>

    <!-- Pop Up fetch invoice data -->
    <FindNomorNota :openModal="!haveNomorNota" @close-modal="setInvoiceData" />

    <!-- Save Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      @click="formatForm"
    >
      New
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";

export default {
  components: {
    FindNomorNota: () => import("@/components/BiayaBongkar/BiayaBuruhModal.vue")
  },
  data() {
    return {
      haveNomorNota: false,
      state: {
        loading: false,
        no_data: true,
        loadingPrint: false,
        noData: true
      },
      loading: {
        nomor_nota: false,
        customers: false,
        invoiceDetil: false,
        ks: false
      },
      findForm: {
        nomor_nota: "",
        nama_kapal: ""
      },
      items: {
        kode_nota: [
          {
            text: "P",
            value: "P"
          },
          {
            text: "L",
            value: "L"
          },
          {
            text: "ND",
            value: "ND"
          }
        ],
        customers: [],
        units: [
          {
            text: "M3",
            value: "M3"
          },
          {
            text: "Ton",
            value: "Ton"
          },
          {
            text: "Unit",
            value: "Unit"
          },
          {
            text: "Container",
            value: "Container"
          }
        ],
        kategoriUpah: [
          "A-Hitung M3",
          "B-Hitung Ton",
          "C-Hitung Koli/Unit",
          "D-Diatas Standar",
          "E-Lainnya"
        ],
        jenisTTPB: ["Kantor", "Pengganti"],
        ks: []
      },
      formData: {},
      invoiceDetil: [],
      invoiceDetilFormData: {
        jumlah: 0,
        harga_satuan: 0
      },
      data: {},
      info: {
        total_koli_in: null,
        total_ton: null,
        total_m3: null,
        nottb: null,
        penerima: null
      },
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  computed: {
    hargaFormInvoiceDetil: {
      get() {
        if (!this.invoiceDetilFormData.harga_satuan) {
          return 0;
        }

        return this.formatCurrency(this.invoiceDetilFormData.harga_satuan);
      },
      set(value) {
        return (this.invoiceDetilFormData.harga_satuan = this.convertToAngka(
          value
        ));
      }
    },
    kalkulasi_upah() {
      if (
        !this.invoiceDetilFormData.jumlah ||
        !this.invoiceDetilFormData.harga_satuan
      ) {
        return 0;
      }

      return this.formatCurrency(
        this.invoiceDetilFormData.jumlah *
          this.invoiceDetilFormData.harga_satuan
      );
    },
    total: {
      get() {
        if (!this.formData.total) {
          return 0;
        }

        return this.formatCurrency(this.formData.total);
      },
      set(value) {
        return (this.formData.total = this.convertToAngka(value));
      }
    },
    total_semua() {
      let totalKalkulasiUpah = this.invoiceDetil.reduce((total, invoice) => {
        return total + invoice.kalkulasi_upah;
      }, 0);

      return this.formatCurrency(totalKalkulasiUpah);
    },
    total_koli() {
      let total = 0;

      if (this.invoiceDetil.length == 0) {
        return total;
      }

      this.invoiceDetil.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(data => {
          total += parseInt(data.koli);
        });
      });

      return total;
    },
    total_kubikasi() {
      let total = 0;

      if (this.invoiceDetil.length == 0) {
        return total;
      }

      this.invoiceDetil.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(data => {
          total += data.m3;
        });
      });

      return total.toFixed(2);
    },
    total_tonase() {
      let total = 0;

      if (this.invoiceDetil.length == 0) {
        return total;
      }

      this.invoiceDetil.forEach(invoice => {
        invoice.ttb.ttb_rinci.forEach(data => {
          total += data.ton;
        });
      });

      return total.toFixed(2);
    },
    tgl_nota_print() {
      let date = new Date(this.formData.tgl_nota);
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${date.getDate()} ${this.months[month]} ${year}`;
    }
  },
  watch: {
    async total(val) {
      this.formData.terbilang = this.pembilang(this.convertToAngka(val));

      if (!this.formData.nomor_nota) return;
    },
    "formData.terbilang"(val) {
      if (!this.formData) {
        this.updateInvoice();
      }
    }
  },
  methods: {
    async printInvoice() {
      this.state.loadingPrint = true;

      await axios
        .get(`biaya-buruh/nota-by-nomor?nomor_nota=${this.formData.nomor_nota}`)
        .then(res => {
          if (!res.data.nomor_nota) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loadingPrint = false;

          setTimeout(() => {
            window.print();
          }, 500);
        })
        .catch(err => {
          this.state.loadingPrint = false;

          alert(err.response.data.message);
        });
    },
    setInvoiceData(val) {
      this.haveNomorNota = true;

      this.formData = val;
      this.fetchInvoiceDetil();
    },
    fetchKs() {
      this.loading.ks = true;

      axios
        .get(`biaya-buruh/ks`)
        .then(res => {
          this.items.ks = res.data.map(data => {
            return {
              text: data.ks + " - " + data.container.no_container,
              value: data.ks
            };
          });

          this.loading.ks = false;
        })
        .catch(err => {
          this.loading.ks = false;

          alert(err.response.data.message);
        });
    },
    fetchKsDetail() {
      axios
        .get(`biaya-buruh/show-ks?ks=${this.invoiceDetilFormData.ttpb}`)
        .then(res => {
          this.info.total_koli_in = res.data.koli_in;
          this.info.total_ton = res.data.ttb.ttb_rinci.reduce(
            (acc, cur) => acc + cur.ton,
            0
          );
          this.info.total_m3 = res.data.ttb.ttb_rinci.reduce(
            (acc, cur) => acc + cur.m3,
            0
          );

          this.info.nottb = res.data.ttb.nottb;
          this.info.penerima = res.data.ttb.penerima_detil.nama_lengkap;

          this.invoiceDetilFormData.keterangan = `${this.info.nottb} (${this.info.penerima})`;
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    fetchInvoice() {
      this.loading.nomor_nota = true;

      axios
        .post(`biaya-buruh/fetch-invoice`, this.findForm)
        .then(res => {
          this.formData = res.data.invoice;
          this.fetchInvoiceDetil();

          this.loading.nomor_nota = false;
        })
        .catch(err => {
          this.loading.nomor_nota = false;

          alert(err.response.data.message);
        });
    },
    fetchInvoiceDetil() {
      this.loading.invoiceDetil = true;

      axios
        .get(`biaya-buruh/invoice-detil?nomor_nota=${this.formData.nomor_nota}`)
        .then(res => {
          this.invoiceDetil = res.data;

          this.loading.invoiceDetil = false;
        })
        .catch(err => {
          this.loading.invoiceDetil = false;

          alert(err.response.data.message);
        });
    },
    updateInvoice() {
      axios
        .put(`biaya-buruh/update/${this.formData.nomor_nota}`, this.formData)
        .then(res => {
          // console.log(res.data);
        })
        .catch(err => {
          alert(err.response.data.message);
        });

      axios
        .put(`kas/biaya-buruh`, {
          no_transaksi: this.formData.nomor_nota,
          subtotal: this.formData.total
        })
        .then(res => {})
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    addInvoiceDetil() {
      this.loading.invoiceDetil = true;

      let formData = {
        kv: this.formData.nomor_nota,
        nomor_nota: this.formData.nomor_nota,
        ttpb: this.invoiceDetilFormData.ttpb,
        jenis_ttpb: this.invoiceDetilFormData.jenis_ttpb,
        kategori_upah: this.invoiceDetilFormData.kategori_upah,
        keterangan: this.invoiceDetilFormData.keterangan,
        jumlah: this.invoiceDetilFormData.jumlah,
        harga_satuan: this.invoiceDetilFormData.harga_satuan
      };

      axios
        .post(`biaya-buruh/add-item`, formData)
        .then(res => {
          if (this.formData.keterangan) {
            this.formData.keterangan += `, ${this.invoiceDetilFormData.keterangan}`;
          } else {
            this.formData.keterangan = `${this.invoiceDetilFormData.keterangan}`;
          }

          this.invoiceDetilFormData.ttpb = "";
          this.invoiceDetilFormData.jenis_ttpb = "";
          this.invoiceDetilFormData.kategori_upah = "";
          this.invoiceDetilFormData.keterangan = "";
          this.invoiceDetilFormData.jumlah = "";
          this.invoiceDetilFormData.harga_satuan = "";

          this.info.total_koli_in = null;
          this.info.total_ton = null;
          this.info.total_m3 = null;
          this.info.nottb = null;
          this.info.penerima = null;

          this.loading.invoiceDetil = false;

          // this.focusInputTTB();
          this.fetchInvoiceDetil();
        })
        .catch(err => {
          this.loading.invoiceDetil = false;

          alert(err.response.data.message);
        });
    },
    deleteItem(id) {
      axios
        .delete(
          `biaya-buruh/delete?kodettb=${id}&nomor_nota=${this.formData.nomor_nota}`
        )
        .then(res => {
          this.fetchInvoiceDetil();
        })
        .catch(err => {
          alert(err.response.data.message);
        });
    },
    formatForm() {
      this.state = {
        loading: false,
        no_vessel: true,
        loadingPrint: false,
        noData: true
      };

      this.findForm = {
        nomor_nota: "",
        nama_kapal: ""
      };

      this.invoiceDetil = [];

      this.haveNomorNota = false;

      this.formData = {};
    },
    getKoli(data) {
      let total = 0;

      data.forEach(invoice => {
        total += parseInt(invoice.koli);
      });

      return total;
    },
    getKubikasi(data) {
      let total = 0;

      data.forEach(val => {
        total += val.m3;
      });

      return total.toFixed(2);
    },
    getTonase(data) {
      let total = 0;

      data.forEach(val => {
        total += val.ton;
      });

      return total.toFixed(2);
    },
    focusInputTTB() {
      this.$nextTick(() => {
        this.$refs.focusNoTTB.$refs.input.click();
      });
    },
    formatDate(date) {
      const newDate = new Date(date);

      return `${String(newDate.getDate()).padStart(2, "0")}-${String(
        newDate.getMonth() + 1
      ).padStart(2, "0")}-${newDate.getFullYear()}`;
    },
    formatCurrency(num) {
      return new Intl.NumberFormat("id-ID").format(num);
    },
    convertToAngka(nilai) {
      if (nilai == "0" || nilai == "" || nilai == null) return 0;

      let desimal = nilai.split(",")[1];
      let angka = nilai
        .split(",")[0]
        .split(".")
        .join("");
      return parseFloat(`${angka}.${desimal}`);
    },
    pembilang(nilai) {
      const _isNominalValid = nilai => {
        const regex = new RegExp(/^\d+$/);
        return !regex.test(nilai);
      };
      const _nominalWording = nilai => {
        const UNIQUE_TWELVE = 12;
        const UNIQUE_TWENTY = 20;
        const UNIQUE_TWO_HUNDRED = 200;
        const UNIQUE_TWO_THOUSAND = 2000;
        const UNIQUE_NAMING = [
          "",
          "Satu ",
          "Dua ",
          "Tiga ",
          "Empat ",
          "Lima ",
          "Enam ",
          "Tujuh ",
          "Delapan ",
          "Sembilan ",
          "Sepuluh ",
          "Sebelas "
        ];
        const TEN = 10;
        const ONE_HUNDRED = 100;
        const ONE_THOUSAND = 1000;
        const ONE_MILLION = 1000000;
        const ONE_BILLION = 1000000000;
        const ONE_TRILLION = 1000000000000;
        if (nilai < ONE_HUNDRED) {
          if (nilai < UNIQUE_TWELVE) return UNIQUE_NAMING[nilai];
          if (nilai < UNIQUE_TWENTY)
            return _nominalWording(nilai % TEN) + "Belas ";
          return (
            _nominalWording(Math.floor(nilai / TEN)) +
            "Puluh " +
            _nominalWording(nilai % TEN)
          );
        }
        if (nilai < ONE_THOUSAND) {
          if (nilai < UNIQUE_TWO_HUNDRED)
            return "Seratus " + _nominalWording(nilai % ONE_HUNDRED);
          return (
            _nominalWording(Math.floor(nilai / ONE_HUNDRED)) +
            "Ratus " +
            _nominalWording(nilai % ONE_HUNDRED)
          );
        }
        if (nilai < ONE_MILLION) {
          if (nilai < UNIQUE_TWO_THOUSAND)
            return "Seribu " + _nominalWording(nilai % ONE_THOUSAND);
          return (
            _nominalWording(Math.floor(nilai / ONE_THOUSAND)) +
            "Ribu " +
            _nominalWording(nilai % ONE_THOUSAND)
          );
        }
        if (nilai < ONE_BILLION)
          return (
            _nominalWording(Math.floor(nilai / ONE_MILLION)) +
            "Juta " +
            _nominalWording(nilai % ONE_MILLION)
          );
        return (
          _nominalWording(Math.floor(nilai / ONE_BILLION)) +
          "Miliar " +
          _nominalWording(nilai % ONE_BILLION)
        );
      };
      if (_isNominalValid(nilai)) return "Nol Rupiah";

      return _nominalWording(nilai) + "Rupiah";
    }
  },
  created() {
    this.fetchKs();
  }
};
</script>

<style scoped>
@media print {
  #section-print {
    /* width: 80mm 300mm; */
    width: 80mm auto;
  }
}

@page {
  /* size: 80mm 300mm; */
  size: 80mm auto;
}

#section-print {
  display: none;
  font-size: 14px;
  width: 80mm;
  /* height: 300mm; */
  height: auto;
}

.table {
  width: 100%;
  border-collapse: collapse;
}

.header {
  display: flex;
  justify-content: space-between;
}

.nomor-nota h6 {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
  border: 1px solid black;
}

.rincian {
  display: flex;
  justify-content: end;
}

.ttd {
  margin-top: 1rem;
  display: flex;
  justify-content: space-around;
}

.total-upah h6 {
  font-size: 1.2rem;
  font-weight: bold;
  text-align: center;
}

.total-upah h6:nth-child(2) {
  border: 1px solid black;
}

.invoice-item {
  border-top: 1px solid lightgray;
  border-bottom: 1px solid lightgray;
}

.overflow-auto {
  overflow: auto !important;
}

.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

#section-print.report {
  padding: 2px;
}

.header {
  display: flex;
}

.left .report-title {
  text-decoration: underline;
}

.right {
  font-style: italic;
  font-weight: bold;
  font-size: 1.1rem;
}

.right .border {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
}

.right .border-dotted {
  text-align: center;
  padding: 0px 10px;
  border: 1px solid black;
  border-style: dashed;
}

@media print {
  #section-print {
    display: inline-block;
  }

  #hide {
    display: none;
  }
}
</style>
